export const EMAIL_IS_PLACEHOLDER_ERROR_CODE = "EMAIL_IS_PLACEHOLDER";

export const AuthErrorCode = {
  INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
  ACCOUNT_DISABLED: "ACCOUNT_DISABLED",
  EMAIL_NOT_VERIFIED: "EMAIL_NOT_VERIFIED",
  EMAIL_ALREADY_USED: "EMAIL_ALREADY_USED",
} as const;

export type AuthErrorCode = (typeof AuthErrorCode)[keyof typeof AuthErrorCode];

export const AUTH_ERROR_MESSAGES = {
  [AuthErrorCode.INVALID_CREDENTIALS]: "Identifiant ou mot de passe incorrect",
  [AuthErrorCode.ACCOUNT_DISABLED]: "Le compte est désactivé",
  [AuthErrorCode.EMAIL_NOT_VERIFIED]: "Veuillez vérifier votre email",
  [AuthErrorCode.EMAIL_ALREADY_USED]: "Un compte existe déjà avec cet email",
} as const satisfies Record<AuthErrorCode, string>;

interface LoginBody {
  emailOrConnectId: string;
  password: string;
}

interface BackofficeLoginBody {
  emailOrConnectId: string;
  password: string;
}

interface SignupBody {
  roles: string[];
  siret?: string;
  vat?: string;
  businessName?: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  acceptedTerms: boolean;
}

interface SignupIndividualBody {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  acceptedTerms: boolean;
}

interface ResendConfirmationMailBody {
  email: string;
}

export type AuthResponseRole = "professional" | "vigil" | "individual" | "cashRegisterHolder";

interface AuthResponse {
  accessToken: string;
  refresh_token: string;
  userRole: AuthResponseRole;
}

interface OtpLink {
  otpAuthUrl: string | null;
}

interface BackofficeAuthResponse extends OtpLink {
  isDoubleAuthNeeded: boolean;
  isDoubleAuthSet: boolean;
}

interface DoubleAuthentificationResponse {
  valid: boolean;
  email: string;
}
interface SignUpResponse {
  email: string;
}

interface ResetPasswordRequestBody {
  email: string;
  fromWebApp: boolean;
}

interface DefinePasswordBody {
  token?: string;
  password: string;
}

interface CreatePasswordBody {
  token?: string;
  password: string;
  firstName: string;
  lastName: string;
}

interface ResetPasswordEmailSentResponse {
  email: string;
}

interface ResolveEmailResponse {
  email: string;
}

export type {
  AuthResponse,
  BackofficeAuthResponse,
  BackofficeLoginBody,
  CreatePasswordBody,
  DefinePasswordBody,
  DoubleAuthentificationResponse,
  LoginBody,
  OtpLink,
  ResendConfirmationMailBody,
  ResetPasswordEmailSentResponse,
  ResetPasswordRequestBody,
  ResolveEmailResponse,
  SignupBody,
  SignupIndividualBody,
  SignUpResponse,
};
